import { LOGGING } from '@/config';
import BaseApi from '@/services/api/BaseApi';
import { makeLogger } from '@/services/utils/logger';
const DEBUG_LOG = true;
const log = makeLogger('AuthService', DEBUG_LOG, LOGGING.AUTH_LOG);

class AuthService extends BaseApi {
  constructor() {
    super(); // basePath по умолчанию ''
  }
  /**
   * Выполняет авторизацию пользователя через Strapi.
   * @param {string} identifier - Email или имя пользователя.
   * @param {string} password - Пароль пользователя.
   * @returns {Promise<Object>} Ответ от сервера с данными пользователя и JWT.
   */
  async getToken(identifier, password) {
    const response = await this.api.post('/auth/local', { identifier, password }, { skipToken: true });
    const token = response.data?.jwt;

    return token;
  }

  async requestPasswordLink(email) {
    await this.api.post('/auth/forgot-password', { email }, { skipToken: true });
  }

  async setPassword(code, password, passwordConfirmation) {
    await this.api.post('/auth/reset-password', { code, password, passwordConfirmation }, { skipToken: true });
  }

  /**
   * Получает текущего пользователя с клубами (используется для авторизации).
   * @returns {Promise<Object>} Десериализованный объект пользователя.
   */
  async getMe() {
    const meResponse = await this.api.get('/users/me', {
      params: {
        // Роль нужна фронтенду для прав и фильтрации changelog.
        // Список сериализуется в стандартный Strapi populate[] без вложенных объектов.
        populate: ['role', 'chess_club'],
      }
    });

    log('getMe', '🔍 Полный ответ /users/me', meResponse);
    log('getMe:data', '🔍 Данные /users/me', meResponse.data);

    const deserializedUser = this.deserialize(meResponse.data);

    return deserializedUser;
  }

  

  /**
   * Преобразует полученного пользователя из ответа API в нужный формат.
   * @param {Object} raw - Объект пользователя из API
   * @returns {Object} Десериализованный объект
   */
  deserialize(raw) {
    const roleEntity = raw.role?.data ?? raw.role ?? null;
    const role = roleEntity?.attributes ?? roleEntity;
    const clubEntity = raw.chess_club?.data ?? raw.chess_club ?? null;
    const club = clubEntity?.attributes ?? clubEntity;

    const user = {
      _dbId: raw.id,
      _publicId: raw.documentId ?? null,
      _clubId: club?.documentId ?? null,
      _clubSlug: club?.slug ?? null,
      _clubName: club?.name ?? null,
      _username: raw.username ?? null,
      _email: raw.email ?? null,
      _role: role && typeof role === 'object'
        ? {
            name: role.name ?? null,
            type: role.type ?? null,
          }
        : null
    };

    log('deserialize', '🔍 Входящие данные', raw);
    log('deserialize', '🔍 Десериализованный юзер', user);
    return user;
  }
};

export default new AuthService();
